import { useEffect, useState } from "react";

export function usePdfBlobUrl(file) {
  const [previewUrl, setPreviewUrl] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl = "";
    let isCurrent = true;

    async function loadPdfPreview() {
      if (!file) return;
      try {
        setError(false);
        setPreviewUrl("");
        const response = await fetch(file);
        if (!response.ok) throw new Error("PDF request failed");
        const bytes = await response.blob();
        objectUrl = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
        if (isCurrent) setPreviewUrl(objectUrl);
      } catch (loadError) {
        if (isCurrent) setError(true);
      }
    }

    loadPdfPreview();

    return () => {
      isCurrent = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [file]);

  return { previewUrl, error };
}

export default function PdfPreview({ file, title, className = "", heightClass = "sn-h-[min(78vh,840px)]", fallbackText = "Having trouble viewing the document? Use Open PDF to view it in a separate tab, or Download PDF to save a copy." }) {
  const { previewUrl, error } = usePdfBlobUrl(file);

  return (
    <div className={`sn-rounded sn-border sn-border-line sn-bg-cream sn-p-3 md:sn-p-4 ${className}`}>
      {previewUrl && !error ? (
        <iframe
          src={`${previewUrl}#toolbar=1&navpanes=0&scrollbar=1&page=1&view=FitH`}
          title={title}
          className={`${heightClass} sn-w-full sn-rounded sn-border sn-border-line sn-bg-white`}
        />
      ) : (
        <div className="sn-flex sn-min-h-[360px] sn-items-center sn-justify-center sn-rounded sn-border sn-border-line sn-bg-white sn-p-6 sn-text-center">
          <div>
            <p className="sn-font-display sn-text-2xl sn-text-forest">
              {error ? "PDF preview could not load." : "Loading PDF preview…"}
            </p>
            <p className="sn-mt-3 sn-text-sm sn-leading-relaxed sn-text-muted">{fallbackText}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export function DocumentActions({ file, fileName, previewUrl, openLabel = "Open PDF", downloadLabel = "Download PDF", className = "" }) {
  return (
    <div className={`sn-flex sn-flex-col sn-gap-3 sm:sn-flex-row ${className}`}>
      <a
        href={previewUrl || file}
        target="_blank"
        rel="noopener noreferrer"
        type="application/pdf"
        className="sn-inline-flex sn-min-h-[48px] sn-items-center sn-justify-center sn-rounded sn-bg-forest sn-px-5 sn-py-3 sn-text-sm sn-font-semibold sn-text-white hover:sn-bg-leaf"
      >
        {openLabel}
      </a>
      <a
        href={file}
        download={fileName}
        className="sn-inline-flex sn-min-h-[48px] sn-items-center sn-justify-center sn-rounded sn-border sn-border-forest/30 sn-px-5 sn-py-3 sn-text-sm sn-font-semibold sn-text-forest hover:sn-bg-cream"
      >
        {downloadLabel}
      </a>
    </div>
  );
}
